import Immutable from 'immutable';
import React from 'react';
import ArtboardLayoutContainerList from 'components/ArtboardLayoutContainerList';
import { CAROUSEL_ITEM_TYPE_HINT_TEXT } from 'components/Carousel/Carousel';
import { CarouselItemDragHotSpot } from 'components/Carousel/CarouselItemDragHotSpot';
import styles from 'components/Carousel/styles.module.scss';
import { useCarouselItemDropTarget } from 'components/Carousel/useCarouselItemDropTarget';
import SlideActions from 'components/CarouselItemSlideActions';
import { CarouselItemType } from 'containers/Layouts/sagas/addCarousel';
import * as Models from 'models';

type Props = {
  carouselId: string;
  documents?: Models.CombinedDocumentsMap;
  getLayoutsRefs?: () => Immutable.Map<string, HTMLDivElement>;
  isSectionActive: boolean;
  isReadOnly: boolean;
  layoutIds: Immutable.List<string>;
  moveableLayoutId?: string;
  relationsByRegularLayoutId?: Immutable.Map<string, Models.LayeredRelationsMap>;
  saveLayoutRef?: (layoutId: string, element: HTMLDivElement) => void;
  section: Models.ExtendedSectionMap;
  slideLayoutsInSlide: Models.CombinedLayoutsList;
  slideId: string;
  number: number;
  sectionDisplayName: string;
  type: CarouselItemType;
  isSlideDeleteDisabled: boolean;
};

const CarouselItemSlide: React.FC<Props> = (props) => {
  const {
    carouselId,
    documents,
    getLayoutsRefs,
    isSectionActive,
    isReadOnly,
    layoutIds,
    moveableLayoutId,
    relationsByRegularLayoutId,
    saveLayoutRef,
    section,
    slideLayoutsInSlide,
    slideId,
    number,
    sectionDisplayName,
    type,
    isSlideDeleteDisabled,
  } = props;
  const sectionId = section.get('id');
  const { canDrop, drop } = useCarouselItemDropTarget({ sectionId, carouselId, type, sectionDisplayName, slideId, slideNumber: number });

  return (
    <div id={slideId} ref={drop} className={styles.carouselItem}>
      <div className={styles.carouselItemType}>{CAROUSEL_ITEM_TYPE_HINT_TEXT[type]} {number}</div>
      <CarouselItemDragHotSpot canDrop={canDrop} />
      <SlideActions
        layoutIds={layoutIds}
        slideLayoutsInSlide={slideLayoutsInSlide}
        isSlideDeleteDisabled={isSlideDeleteDisabled}
        dataTestId={`Carousel-${carouselId}-${'Slide'}-${slideId}-SlideActions`}
        carouselId={carouselId}
        sectionId={sectionId}
        slideId={slideId}
        currentSlideNumber={number}
      />
      <ArtboardLayoutContainerList
        documents={documents}
        getLayoutsRefs={getLayoutsRefs}
        isSectionActive={isSectionActive}
        layoutIds={layoutIds}
        isReadOnly={isReadOnly}
        layouts={slideLayoutsInSlide}
        moveableLayoutId={moveableLayoutId}
        relationsByRegularLayoutId={relationsByRegularLayoutId}
        saveLayoutRef={saveLayoutRef}
        section={section}
        ssi={null}
        dataTestId={`Carousel-${carouselId}-${'Slide'}-${slideId}-ArtboardLayoutContainerList`}
      />
    </div>
  );
};

export default CarouselItemSlide;
